export const PAGE_SIZE_OPTIONS = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' }
];

export const ADMIN_VIEW_COLUMNS = 4;
export const USER_VIEW_COLUMNS = 3;
